module.exports = __webpack_public_path__ + "img/popup-close-icon.a2e09a2e.svg";